<template>
    <div v-if="canManage">
        <settings-heading
            :title="$t('settings.vacancy_reasons.title')"
            :description="$t('settings.vacancy_reasons.description')"
        />
        <div>
            <job-reasons :fetchingReasons="fetchingReasons" :reasons="requestReasons"></job-reasons>
            <job-reasons :fetchingReasons="fetchingReasons" :reasons="rejectReasons" :isRejected="true"></job-reasons>
        </div>
    </div>
    <error-403 v-else></error-403>
</template>

<script>
import { mapState } from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';
import Toggle from '../../components/forms/Toggle.vue';
import Error403 from '../../components/ui/Error403.vue';
import Input from '../../components/forms/Input.vue';
import SimpleButton from '../../components/ui/SimpleButton.vue';
import JobReasons from "../../components/JobReasons";
import PopupModalConfirm from '../../components/ui/PopupModalConfirm.vue';
import JobReason from "../../models/JobReason";
import * as jobReasonService from "../../services/JobReasonService";
import {normalizeJson} from "../../../shared/helpers";
import SettingsHeading from "../../components/ui/SettingsHeading.vue";

export default {
    components: {
        SettingsHeading,
        Toggle,
        'error-403': Error403,
        'simple-input': Input,
        'simple-button': SimpleButton,
        'popup-modal-confirm': PopupModalConfirm,
        JobReasons
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany', 'selectedLocale']),
        reasons: {
            get () {
                return useRepo(JobReason).get();
            },
            set (reasons) {
                this.resort(reasons);
            }
        },
        requestReasons() {
            return this.jobReasons();
        },
        rejectReasons() {
            return this.jobReasons(1);
        },
        languages() {
            return this.currentCompany.jobsite.active_languages;
        },
    },
    data: function () {
        return {
            fetchingReasons: false,
            canManage: this.$can('settings.vacancies'),
        }
    },
    methods: {
        jobReasons(rejected = 0) {
            let reasons = useRepo(JobReason)
                .where('is_rejected', rejected)
                .get()
                .sort((a,b) => a.title[this.selectedLocale]?.localeCompare(b.title[this.selectedLocale]));
            reasons.forEach((reason) => {
                this.formatTranslations(reason)
            })
            return reasons
        },
        fetchReasons() {
            return jobReasonService.index().then(({data}) => {
                return useRepo(JobReason).save(normalizeJson(data))
            })
        },
        formatTranslations(reason) {
            this.languages.forEach((lang) => {
                if (!reason.title[lang]) {
                    reason.title[lang] = null
                }
            })
        },
    },
    mounted() {
        this.fetchingReasons = true;

        this.fetchReasons().then(inserts => {
            this.fetchingReasons = false;
        });
    }
}
</script>
